import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';

import type { LocationDetails } from '../modal/location';

export interface LocationDetailsForm {
  fieldName: string;
}

export const createLocationAPI = async (
  locationDetails: LocationDetailsForm,
) => {
  const resp = await baseAPI.post<LocationDetails>(
    '/custom-form/location',
    locationDetails,
  );
  return resp.data;
};

export const useCreateLocationMutation = () => {
  return useMutation({
    mutationFn: async (locationDetails: LocationDetailsForm) => {
      const response = await createLocationAPI(locationDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['locations'],
      });
    },
  });
};
